import { Component, OnInit, inject } from '@angular/core';
import { BatchStatusActionsService, VersionCheckService } from '@capturum/complete';
import { DownloadUrlAction } from '@core/batch-status-actions/download-url.service';
import { RouterOutlet } from '@angular/router';
import { CapturumToastComponent } from '@capturum/ui/toast';

@Component({
  selector: 'app-root',
  template: `
    <router-outlet></router-outlet>
    <cap-toast></cap-toast>
  `,
  providers: [VersionCheckService],
  imports: [RouterOutlet, CapturumToastComponent],
})
export class AppComponent implements OnInit {
  private batchStatusActionService = inject(BatchStatusActionsService);

  public ngOnInit(): void {
    this.batchStatusActionService.addActions({ download_url: DownloadUrlAction });
  }
}
